import React, {useEffect, useState, Fragment} from 'react'
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    FormControl,
    InputGroup,
    OverlayTrigger,
    Row,
    Tooltip
} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'
import { LoadingComponent } from 'recupero-comunes'
import { obtenerGrillaBusqueda } from '../../store/actions/trazabilidad-hitos-action'

const SeguimientosHitos = ({setListaGrilla, handleClose}) => {
    const [loading, setLoading]=useState(false)
    const data_solicitud_modal = useSelector((state) => state.solicitudDescuentoReducer)
    const {cfg_form17, comboMotivoDescuento} = data_solicitud_modal

    const data_traza_modal = useSelector((state) => state.trazabilidadReducer)
    const {cfg_form18,comboTipoGestion,comboCAmbitoGestion,datosGestion} = data_traza_modal

    


    const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
  const { llaves} = data_recepciona
   

    const [idCarpetaResExt, setIdCarpetaResExt] = useState('')
    const [fechaAudiencia, setFechaAudiencia] = useState('')
    // const [fechaHitoContacto, setFechaOcurrencia] = useState("")
    const [codHitoContacto, setCodHitoContacto] = useState('')
    const [minutaHitoContacto, setMinutaHitoContacto] = useState('')
    const [fechaHitoContacto, setFechaHitoContacto] = useState('')

    const [open, setOpen] = React.useState(false)
    const [hidden, setHidden] = React.useState(false)
    const [tipoGestion, setTipoGestion] = React.useState(false)
    const [ambitoGestion, setAmbitoGestion] = React.useState(false)
    const [historialAsignado, setHistorialAsignado] = React.useState(false)


    const [miMontoNeto, setMiMontoNeto] = useState(0)
    const dispatch = useDispatch()

   
    useEffect(() => {
        setTipoGestion(datosGestion && datosGestion.datosGestion[0]!==undefined && datosGestion.datosGestion[0]['codTipoGestion'] !== '' && datosGestion.datosGestion[0]['codTipoGestion'] !== null && datosGestion.datosGestion[0]['codTipoGestion'] !== undefined ? parseInt(datosGestion.datosGestion[0]['codTipoGestion']) : '')
        setAmbitoGestion(datosGestion &&  datosGestion.datosGestion[0]!==undefined && datosGestion.datosGestion[0]['codAmbitoGestion'] !== '' && datosGestion.datosGestion[0]['codAmbitoGestion'] !== null && datosGestion.datosGestion[0]['codAmbitoGestion'] !== undefined ? parseInt(datosGestion.datosGestion[0]['codAmbitoGestion']) : '')
    }, [datosGestion])

    const convertirFecha = (fecha) => {
        if (fecha !== null && typeof fecha !== undefined) {
            const [dia, mes, ano] = fecha ?. split('-')
            const fechaFormat = [ano, mes, dia].join('-')

            return fechaFormat
        } else 
            return null
        
    }
    const handleOpen = () => {
        setOpen(true)
    }

    
    const handleAction = (action) => {
        console.log(action)
    }

    const formik = useFormik({
        initialValues: {
            idCaso: '',
            idImplicadoCaso: '',
            idOrganizacion: '',
            idCarpetaResExt: '',
            codTipoGestion: '',
            codAmbitoGestion: '',
            glosaAmbitoGestion: '',
            codIntanciaGestion: '',
            fechaAudiencia: '',
            codHitoContacto: '',
            fechaHitoContacto: '',
            minutaHitoContacto: '',
            codHitoRespuesta: '',
            fechaHitoRespuesta: '',
            minutaHitoRespuesta: '',
            recepciona: '',
            aliasApp: '',
            idUsuario: ''
        },
        // validationSchema: validationSchemas(isModoContacto,isRespuestaContacto),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = llaves && llaves['idUsuario']
            dataForm['codTipoGestion'] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion']
            dataForm['codAmbitoGestion'] = datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion']
            dataForm['aliasApp'] = 'RECEPASICASO'
            dataForm['recepciona'] = 0

            dispatch(actualizarExtrajudicial(dataForm))
        }
    })
    const handleBuscar = () => {
       
            if (llaves) {
                setLoading(true)
                let query = Buffer.from(JSON.stringify({
                    idCaso: llaves && llaves['idCaso'],
                    idImplicado: llaves && llaves['idImplicado'],
                    "idModoIngreso1":null, 
                     "idModoIngreso2":null, 
                     tipoGestion:tipoGestion,
                     ambitoGestion:ambitoGestion,
                     responsableReasignado:historialAsignado
                })).toString('base64')
                dispatch(obtenerGrillaBusqueda(query)).then(()=>setLoading(false))
            }       
            
    }
    const handleLimpiar =()=>{
        setListaGrilla('')
        setTipoGestion('')
        setAmbitoGestion('')
    }
    const handleCheck =(e)=>{
        setHistorialAsignado(e.target.checked)
    }

    return (
        <>
            <style type='text/css'>
                {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }    
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    `} </style>
            <LoadingComponent show={loading}/>
            <Form onSubmit={
                formik.handleSubmit
            }>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6'
                        style={
                            {
                                backgroundColor: '#4F517A',
                                color: 'white'
                            }
                    }>
                        {
                        cfg_form18 ? cfg_form18.cfg_form18['seguimientohitos-title-seguimiento'] : ''
                    } </Card.Header>
                    <Container>
                        <Container> {
                            cfg_form18 ? (
                                <div>

                                    <Container>
                                        <Row>


                                            <Col md="3">
                                                <Form.Label className='mt-2'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form18.cfg_form18['seguimientohitos-cmb-tipogestion']
                                                } </Form.Label>
                                                <br/>
                                                <Form.Select className='mt-2' aria-label='Default select example'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setTipoGestion(e.target.value)

                                                        }
                                                    }
                                                    name='tipoGestion'
                                                    value={
                                                        (formik.values.tipoGestion = tipoGestion)
                                                    }
                                                    //error={formik.errors.codHitoContacto}
                                                >
                                                    <option value={''}>Seleccione...</option>
                                                    {
                                                    comboTipoGestion && comboTipoGestion.comboTipoGestion ?. map((c) => (
                                                        <option key={
                                                                c.id
                                                            }
                                                            value={
                                                                c.id
                                                        }>
                                                            {
                                                            c.nombre
                                                        } </option>
                                                    ))
                                                } 
                                                </Form.Select>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-0 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form18.cfg_form18['seguimientohitos-cmb-ambitogestion']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select className='mt-2 w-75' aria-label='Default select example'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setAmbitoGestion(e.target.value)

                                                        }
                                                    }
                                                    name='ambitoGestion'
                                                    value={
                                                        (formik.values.ambitoGestion = ambitoGestion)
                                                    }
                                                    //error={formik.errors.codHitoContacto}
                                                >
                                                    <option value={''}>Seleccione...</option>
                                                    {
                                                    comboCAmbitoGestion && comboCAmbitoGestion.comboCAmbitoGestion ?. map((c) => (
                                                        <option key={
                                                                c.id
                                                            }
                                                            value={
                                                                c.id
                                                        }>
                                                            {
                                                            c.nombre
                                                        } </option>
                                                    ))
                                                } 
                                                </Form.Select>
                                            </Col>
                                            <Col>
                                                <Form.Check className='mt-5' type='checkbox' id='historial' label='Historial Reasignado' onChange={(e)=>handleCheck(e)}/>
                                            </Col>

                                        </Row>
                                    </Container>

                                    <hr style={
                                        {
                                            color: '#04005D',
                                            height: '2px',
                                            marginTop: '30px'
                                        }
                                    }></hr>
                                    <Container>
                                        <Row>
                                            <Col className='d-flex align-items-end justify-content-end m-2'>
                                                <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}>
                                                    {
                                                    cfg_form18 && cfg_form18.cfg_form18["seguimientohitos-btn-cerrar"]
                                                } </Button>


                                                <Button className='m-2' variant='carpeta' name='limpiar' onClick={handleLimpiar}>
                                                    {
                                                    cfg_form18 && cfg_form18.cfg_form18["seguimientohitos-btn-limpiar"]
                                                } </Button>
                                                <Button className='m-2' variant='actualizar'
                                                    onClick={handleBuscar}

                                                    name='buscar'>
                                                    {
                                                    cfg_form18 && cfg_form18.cfg_form18["seguimientohitos-btn-buscar"]
                                                } </Button>

                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            ) : null
                        } </Container>
                    </Container>
                </Card>
            </Form>
        </>
    )
}

export default SeguimientosHitos
